<template>
  <footer class="page-footer">
    <div class="page-container">
      <slot name="top"></slot>
      <FooterMenu />
      <FooterCopyright />
    </div>
  </footer>
</template>

<script>
import FooterMenu from './FooterMenu'
import FooterCopyright from './FooterCopyright'

export default {
  name: 'VueFooter',
  components: {
    FooterMenu,
    FooterCopyright
  },
  mounted () {}
}
</script>

<style scoped lang="sass">

.page-footer
  background-color: #1F1F20
  width: 100%
  //margin-top: 40px
  //margin-top: 70px
  //
  //+mmin($tablet)
  //  margin-top: 60px

.advantage--footer + .page-footer
  margin-top: 70px

  +mmin($tablet)
    margin-top: 60px

.page-footer__wrap
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  padding: 52px 0 45px

  +mmax(768)
    flex-flow: column
    padding: 10px 0 40px
</style>
